/* @flow */
import * as React from 'react';

import AccountNavigation from 'user/components/AccountNavigation.jsx';
import NavigationList from 'components/NavigationList';
import RecentViewListener from 'app/components/RecentViewListener.jsx';

import './styles/AppSidebarLayout.scss';

type Props = {
  children?: React.Node,
};

export default function AppSidebarLayout(props: Props) {
  return (
    <div className="AppSidebarLayout">
      <div className="AppSidebarLayout-inner">
        <RecentViewListener />
        <div className="AppSidebarLayout-heightSetter">
          <div className="AppSidebarLayout-contentWrap">
            <div className="AppSidebarLayout-sidebar">
              <AccountNavigation />
              <NavigationList />
            </div>
            <div className="AppSidebarLayout-content">{props.children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
